import React from "react";

/*creates context of currentUser state which can then
be passed on */

const CurrentUserContext = React.createContext();

export default CurrentUserContext;